<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" :title="title">
          <div slot="content">
            <div class="form-group col-md-12 col-sm-12 col-xs-12">
              <label>Trạng thái tài khoản</label>
              <b-form-checkbox v-model="user.status" switch size="lg"></b-form-checkbox>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCompany ? 'has-error' : ''">
              <label>Công ty<span class="error-symbol"></span></label>
              <multiselect v-model="selectedCompany" id="ajax" label="name" track-by="code"
                           placeholder="Nhập để tìm công ty..."
                           :isRequire="errorCompany"
                           open-direction="bottom" :options="companies" :multiple="false" :searchable="true"
                           :loading="loadingCompany" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceCompany">
              </multiselect>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorUsername ? 'has-error' : ''">
              <label>Tài khoản<span class="error-symbol"></span></label>
              <input type="text" class="form-control" autocomplete="new-password" v-model="user.username" placeholder="Nhập tài khoản ..." @keyup="reformatUserName"/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPassword ? 'has-error' : ''">
              <label>Mật khẩu<span v-show="!isEdit()" class="error-symbol"></span></label>
              <input type="password" class="form-control" autocomplete="new-password" v-model="user.password" placeholder="Nhập mật khẩu ..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorRepeatPassword ? 'has-error' : ''">
              <label>Nhập lại mật khẩu<span v-show="!isEdit()" class="error-symbol"></span></label>
              <input type="password" class="form-control" autocomplete="new-password" v-model="user.repeat_password"
                     placeholder="Nhập lại mật khẩu ..."/>
              <span v-show="errorRepeatPassword" class="help-block">Mật khẩu không khớp</span>
            </div>
          </div>
          <div slot="footer">
            <div class="pull-right">
              <b-button variant="success" class="w-100px" @click="save">Lưu</b-button>
              <b-button variant="warning" class="w-100px" @click="back">Trờ về</b-button>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import UserAPI from '../../../api/user'
import Utils from '../../../common/utils'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect'
import CompanyAPI from '../../../api/company'
import {debounce} from 'lodash'

export default {
  name: 'AdminDetail',
  components: {
    'va-box': VABox,
    Multiselect
  },
  data () {
    return {
      user: {
        id: null,
        company_id: null,
        username: '',
        password: '',
        repeat_password: '',
        status: true
      },
      click: false,
      loading: false,
      saving: false,
      loadingCompany: false,
      companies: [],
      selectedCompany: null,
      debounceCompany: null,
      title: ''
    }
  },
  created () {
    this.debounceCompany = debounce(this.filterCompany.bind(this), 500)
  },
  computed: {
    errorCompany () {
      return this.click && (this.selectedCompany == null || this.selectedCompany.length === 0)
    },
    errorUsername () {
      return this.isEmpty(this.user.username)
    },
    errorPassword () {
      return this.isEmpty(this.user.password) && !this.isEdit()
    },
    errorRepeatPassword () {
      return this.click && this.user.password != null && this.user.password !== '' && this.user.password !== this.user.repeat_password && !this.isEdit()
    }
  },
  mounted () {
    this.init()
    this.filterCompany()
    this.title = this.isEdit() ? 'Cập nhật tài khoản admin' : 'Thêm tài khoản admin mới'
  },
  methods: {
    isEdit () {
      return !!this.$route.params.id
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    init () {
      this.getUserDetail()
    },
    async getUserDetail () {
      const id = this.$route.params.id
      if (id) {
        this.loading = true
        const user = (await UserAPI.findById(id)).data.data
        user.roles.forEach(item => {
          this.selectedCompany = {
            code: item.company.id,
            name: item.company.name
          }
        })

        this.user.company_id = this.selectedCompany.code
        this.user.username = user.username
        this.user.id = id
        this.user.status = user.status
        this.loading = false
      }
      return null
    },
    back () {
      this.$router.push({name: 'AdminList'})
    },
    validate () {
      return !this.errorCompany && !this.errorUsername && !this.errorPassword && !this.errorRepeatPassword
    },
    save () {
      this.click = true
      this.saving = true
      this.loading = true
      if (!this.validate()) {
        this.saving = false
        this.loading = false
        return
      }
      const id = this.$route.params.id

      if (this.user.company_id === null || this.user.company_id === '') {
        this.user.company_id = this.selectedCompany.code
      }
      const data = {...this.user}
      delete data.repeat_password

      if (id) {
        if (data.password === '') {
          delete data.password
        }
        UserAPI.update(data).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
          }
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        UserAPI.create(data).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.back()
          }
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    filterCompany (query) {
      this.loadingCompany = true
      CompanyAPI.findByName(query, 0, 20).then(res => {
        this.companies = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingCompany = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCompany = false
      })
    },
    reformatUserName () {
      this.user.username = this.user.username.replace(' ', '')
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/user-admin/AdminDetail.vue